module.exports = __webpack_public_path__ + "static/img/1-2.1090ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/1-2.png
// module id = +4U9
// module chunks = 0